import PropTypes from 'prop-types';
import React from 'react';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router';
import classNames from 'classnames';

import logo from '../../../../public/catch-logo.png';
import RegisterAgencyForm from './RegisterAgencyForm';

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit(values) {
    console.log('handle registration submit: ', values);
    const payload = values;
    this.props.registerAgency(payload);
  }
  render() {
    let statusText = null;
    if (this.props.status) {
      const statusTextClassNames = classNames({
        alert: true,
        'alert-danger': this.props.status.indexOf('Authentication Error') === 0,
        'alert-success': this.props.status.indexOf('Authentication Error') !== 0,
      });

      statusText = (
        <div className="row">
          <div className="col-sm-12">
            <div className={statusTextClassNames}>
              {this.props.status}
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="container login">
          <div className="row">
            <div className="col-md-4 center-block">
              <div className="center-block-inner">
                <img className="" src={logo} alt="Catch" />
              </div>
              <div style={{padding: '60px 60px 60px 60px'}}>
                <h4 className="text-left">Welcome to group travel simplified</h4>
                <br />
                <div className="login-container margin-top-medium">
                  {statusText}
                  <RegisterAgencyForm onSubmit={this.handleSubmit} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Register.propTypes = {
  registerAgency: PropTypes.func.isRequired,
  status: PropTypes.string,
};

export default Register;



// WEBPACK FOOTER //
// src/routes/agency/components/Register.js